import type {PublishingAsWebpageResponse} from '@Panels/poster-publishing-options-panel/components/publishing-as-webpage-panel/publishing-as-webpage-panel.types';
import {PublishingAsWebpageType} from '@Panels/poster-publishing-options-panel/components/publishing-as-webpage-panel/publishing-as-webpage-panel.types';

export const fetchPublishAsWebpageMeta = async (type: PublishingAsWebpageType, itemHashedId: string): Promise<PublishingAsWebpageResponse> => {
  if (type === PublishingAsWebpageType.PUBLISH_POSTER) {
    return (await window.PMW.readLocal('poster/showShareHostedLinkPanelNew/', {posterId: itemHashedId})) as Promise<PublishingAsWebpageResponse>;
  }

  return (await window.PMW.readLocal('emailmarketing/getIsPublishedMeta/', {idCampaign: itemHashedId})) as Promise<PublishingAsWebpageResponse>;
};

export const handlePublishRequest = (type: PublishingAsWebpageType, itemHashedId: string): Promise<boolean> => {
  const urlPath = type === PublishingAsWebpageType.PUBLISH_POSTER ? 'poster/publishShareHostedLinkPanelNew/' : 'emailmarketing/publishEmailMarketingCampaign';
  return window.PMW.writeLocal(urlPath, {hid: itemHashedId});
};

export const handleUnpublishRequest = (type: PublishingAsWebpageType, itemHashedId: string): Promise<boolean> => {
  const urlPath = type === PublishingAsWebpageType.PUBLISH_POSTER ? 'poster/unpublishShareHostedLinkNew/' : 'emailmarketing/unpublishEmailMarketingCampaign';
  return window.PMW.writeLocal(urlPath, {hid: itemHashedId});
};
